// extracted by mini-css-extract-plugin
module.exports = {"container":"TopicChooser__container___2Qual","wrapper":"TopicChooser__wrapper___11aVg","headline":"TopicChooser__headline___1plUq","infotext":"TopicChooser__infotext___2ZzdX"};